<template>
    
      <form-group
        :validator="setValidationRules()"
        :messages="localMessages"
        class="question-simu inputField-simulator"
        :class="{ validate: !setValidationRules().$invalid && setValidationRules().$dirty }"
      >
          
          <h2 class="question-simu__title">{{ questionDatas.title }}</h2>

          <div 
            class="question-simu__content"
            :class="{
              withOption: questionDatas.options,
              customQuestionInput : isCustomNumberInput()
            }"
          >

            <!-- Custom input btn -->
            <button 
              v-if="isCustomNumberInput()"
              @click="decrementCustomInput()"
              class="custom-input__btn"
            >-</button>
            
            <!-- Input -->
            <div 
              class="question-simu__input-container"
              :class="{ customNumberInput : isCustomNumberInput()}"
            >
              <input 
                class=""
                v-model.trim="formFields[currentField]"
                :type="inputType" 
                :placeholder="questionDatas.placeholder"
                @input="triggerValidation()"
              />
              <span class="input-unit" v-html="unit[`${questionDatas.key}`]"></span>
            </div>

            <!-- Custom input btn -->
            <button
              v-if="isCustomNumberInput()"
              @click="incrementCustomInput()"
              class="custom-input__btn"
            >+</button>

            <!-- option -->
            <div 
              v-if="questionDatas.options"
              class="input-option"
              @click="triggerOptionAction"
            >
                {{questionDatas.options.label}}
            </div>

          </div>

          <!-- Display error mess onClick continue -->
          <div 
              class="form-error"
              :class="{displayed: displayErrorMessage && setValidationRules().$invalid}"
          >
              {{localMessages.required}}
          </div> 
       
      </form-group>
    
</template>

<script>
import { required, minValue, maxValue, email, helpers } from "vuelidate/lib/validators";

// Regex validator
const postalCodeValidator = helpers.regex("formatSimulator", /^(?:[0-8]\d|9[0-9])\d{3}$/);


export default {
    name: "InputQuestion",

    props: {
        questionDatas: {
            type: Object,
            default: {},
        },
        inputType: {
            type: String,
            default: ''
        },
        currentAnswer: {
            type: String,
            default: '',
        },
        displayErrorMessage: {
            type: Boolean,
            default: false
        }
    },

    computed: {
      //Watch nested object
      formFieldsPostalCode(){
          return this.formFields.postalCode;
      },
      formFieldsAnswer(){
          return this.formFields.answer;
      },
      formFieldsHousingArea(){
          return this.formFields.housingArea;
      }
    },

    data() {
        return {
            formFields: {
              answer: this.currentAnswer,
              postalCode: this.currentAnswer,
              housingArea: this.currentAnswer,
            },
            currentField: '',
            localMessages: {
              required: 'Veuillez remplir ce champs',
              postalCodeValidator: "Ce format n'est pas valide, ex: 67100",
              minValue: 'Veuillez remplir ce champs',
              maxValue: 'Surface maximum: 400m2'
            },
            unit: {
              mcp_energy_bill_amount: "€",
              mcp_housing_area: "m<small>2</small>",
            },
            customInputsNumber: ['mcp_person_in_household'],
            unbounceValidationTimer: null,
        };
    },

    validations: {
      formFields: {
        answer: {
          required,
          minValue: minValue(1)
        },

        postalCode: {
          required,
          postalCodeValidator,
        },
        
        housingArea: {
          required,
          maxValue: maxValue(400)
        }
      },
    },

    methods: {
      /**
       * Set dynamically custom rules validation
       */
      setValidationRules() {
        switch (this.questionDatas.key) {
          case 'mcp_intervention_code':
            this.currentField = 'postalCode'
            return this.$v.formFields.postalCode;
          case 'mcp_housing_area':
            this.currentField = 'housingArea'
            return this.$v.formFields.housingArea;
          default:
            this.currentField = 'answer'
            return this.$v.formFields.answer;
        } 
      },

      /**
       * validation with/without delay
       */
      triggerValidation() {
        switch (this.questionDatas.key) {
          case 'mcp_intervention_code':
            this.unbounceValidation()
            break;
          default:
            this.setValidationRules().$touch();
            break;
        }
      },

      /**
       * option action
       */
      triggerOptionAction() {
        //Save answer
        this.$emit('Answer::choice', this.questionDatas.key, '');
        this.$emit('InputOption::continue-tunnel')
      },


      /**
       * Custom input with increment/decrement btn
       */
      isCustomNumberInput() {
        return this.customInputsNumber.includes(this.questionDatas.key)
      },

      incrementCustomInput() {
        this.setValidationRules().$touch()
        this.formFields.answer += 1
      },

      decrementCustomInput() {
        this.setValidationRules().$touch()
        if(this.formFields.answer > 0) this.formFields.answer -= 1
      },

      /**
       * set typing delay before validation
       * (for postalCode question)
       */
      unbounceValidation() {
        if(this.unbounceValidationTimer) {
          this.setValidationRules().$reset();
          clearTimeout(this.unbounceValidationTimer);
        }

        this.unbounceValidationTimer =  setTimeout(()=>{ 
                                          this.setValidationRules().$touch()
                                        }, 1000);
      }
    },

    watch: {

      /**
       * watch formField.postalCode
       */
      formFieldsPostalCode() {
        //Hide required error message from Parent component
        this.formFields.postalCode.length > 0 ? this.displayErrorMessage = false : '';

        if(!this.setValidationRules().$invalid) {
          this.$emit('Answer::choice', this.questionDatas.key, this.formFields.postalCode, true)
        } else if(this.setValidationRules().$invalid) {
          this.$emit('Answer::invalid')
        }
      },

      /**
       * Watch formField.answer
       */
      formFieldsAnswer() {
        this.formFields.answer.length > 0 ? this.displayErrorMessage = false : '';

        if(!this.setValidationRules().$invalid && this.setValidationRules().$dirty) {
          this.$emit('Answer::choice', this.questionDatas.key, this.formFields.answer)
        } else if(this.setValidationRules().$invalid) {
          this.$emit('Answer::invalid')
        }
      },

      formFieldsHousingArea() {
        this.formFields.housingArea.length > 0 ? this.displayErrorMessage = false : '';

        if(!this.setValidationRules().$invalid && this.setValidationRules().$dirty) {
          this.$emit('Answer::choice', this.questionDatas.key, this.formFields.housingArea)
        } else if(this.setValidationRules().$invalid) {
          this.$emit('Answer::invalid')
        }
      }

    },

    created() {
      //Input value start at 0 for custom input number
      if(this.isCustomNumberInput() && !this.formFields.answer) this.formFields.answer = 0
    },
    
    
}
</script>

<style lang="scss" scoped>
.question-simu {
  &__content.customQuestionInput {
      display: flex;
  }

  &__content {

    .input-option {
      cursor: pointer;
      position: relative;
      width: fit-content;
      margin-left: auto;
      color: $c-grey-3;
      font-size: 2rem;
      font-weight: $fw-robotoM;
      margin-top: 8vw;
      
      //underline
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: $c-grey-3;
        transform: scaleX(1);
        transform-origin: left;
        transition: transform .2s ease-in;
      }
      
      &:hover {
        color: $c-mcp-red;
        
        &::after {
          transform: scaleX(0);
        }
      }
    }
  }

  &__input-container {
    position: relative;
    flex: 1;

    // custom input with btn
    &.customNumberInput {
        margin: 0 10px;

        input[type=number] {
          text-align: center;
        }
    }
  }
}

.question-simu {
  // screen 768pxpx
  @include breakpoint(md) {

    &__content.withOption {
      display: flex;
      align-items: center;

      .input-option {
        margin: 0 5vw;
        margin-top: 0;
      }
    }
  }
}

//No double error message for postal-code input
.inputField-simulator.error:has(.form-error.is-visible) {
  .form-error.displayed {
    display: none;
  }
}
</style>